import React from "react";
import Img from "gatsby-image";

import Arrows from "./Arrows";
import CardInterviewsList from "./CardInterviewsList";
import CardWorkedList from "./CardWorkedList";
import Social from "./Social";
import Contact from "./Contact";
import HeroBgIntroVideo from "./HeroBgIntroVideo";

/**
 * View: Present
 * @param {Object} heroBgWhat Image data for What card hero background
 * @param {Object} heroBgHow Image data for How card hero background
 * @param {Object} heroBgInterviews Image data for Interviews card hero background
 * (Note: add heroBgIntro as an incoming prop if using image as hero background instead of video in intro card. And then use <Img fluid={heroBgIntro.childImageSharp.fluid} /> in place of the <video>.)
 */
export default function ViewPresent({
  heroBgIntro,
  heroBgIntroMobile,
  heroBgWhat,
  heroBgWhatMobile,
  heroBgHow,
  heroBgHowMobile,
  heroBgInterviews,
  heroBgInterviewsMobile
}) {
  const introSources = [
    heroBgIntroMobile.childImageSharp.fluid,
    {
      ...heroBgIntro.childImageSharp.fluid,
      media: `(min-width: 768px)`,
    },
  ]

  const whatSources = [
    heroBgWhatMobile.childImageSharp.fluid,
    {
      ...heroBgWhat.childImageSharp.fluid,
      media: `(min-width: 768px)`,
    },
  ]

  const howSources = [
    heroBgHowMobile.childImageSharp.fluid,
    {
      ...heroBgHow.childImageSharp.fluid,
      media: `(min-width: 768px)`,
    },
  ]

  const interviewSources = [
    heroBgInterviewsMobile.childImageSharp.fluid,
    {
      ...heroBgInterviews.childImageSharp.fluid,
      media: `(min-width: 768px)`,
    },
  ]

  return (
    <section id="view-1" className="view view-1">
      <div className="card card--intro hero">
        <div className="hero__wrap">
          <div className="hero__inner inner inner--intro-1">
            <h1 className="hdg-main">
              <span>Hey, I’m</span>{" "}
              <span className="hdg-main__major hdg-main__major--view-1">
                Nick Ferrara
              </span>{" "}
              <span className="hdg-main__tagline">
                A host and emcee from <br />
                Los Angeles.
              </span>{" "}
              <span>This is my story.</span>
            </h1>
          </div>
        </div>

        <Arrows viewId="1" toCardId="1" color="light" size="lg" />
        {/* <HeroBgIntroVideo /> */}
        <Img fluid={introSources} imgStyle={{ objectPosition: "50% 25%" }} />
      </div>

      {/* Card 1: Traveled */}
      <div id="view-1-card-1" className="card card--traveled">
        <div className="inner">
          <h2 className="hdg-2 hdg-2--traveled ctr">
            I’ll Host Events Anywhere, I’ve Been To...
          </h2>

          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 321 420" className="globe">
            <defs>
              <path id="a3hzwmt4na" d="M0.295 0L193.18 0 193.18 200.305 0.295 200.305z" />
              <path id="z2vzudqdqc" d="M0 0.355L198.088 0.355 198.088 43.484 0 43.484z" />
              <path id="dghh24dr8e" d="M0.267 0.153L40.798 0.153 40.798 29.815 0.267 29.815z" />
              <path id="cfb46zsibj" d="M0 0L94.31 0 94.31 24.128 0 24.128z" />
              <path id="46qn2miy8l" d="M0 0L89.119 0 89.119 35.745 0 35.745z" />
              <ellipse id="glx9v4bs2g" cx="36.34" cy="36.8" rx="36.006" ry="36.8" />
              <ellipse id="issworxy8i" cx="38.27" cy="50.566" rx="31.947" ry="33.434" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <g>
                <g>
                  <g>
                    <g>
                      <g>
                        <g>
                          <g transform="translate(-796 -331) translate(796 331) translate(12.978 62.553) translate(19.035 47.362) translate(3.683) translate(30.117)">
                            <mask id="jbxqthwzub" fill="#fff">
                              <use xlinkHref="#a3hzwmt4na" />
                            </mask>
                            <path fill="#3E5473" d="M160.763 165.544c-13.858 14.296-31.455 23.33-50.516 26.141 7.093-8.423 16.076-21.824 22.735-41.09h39.554c-3.376 5.33-7.307 10.341-11.773 14.949zm-61.628 27.063c-.586.011-1.171.022-1.758.022-.42 0-.837-.01-1.254-.015-4.208-4.138-11.323-12.167-18.065-24.61-2.988-5.514-5.604-11.324-7.845-17.41h54.824c-2.24 6.086-4.856 11.896-7.844 17.41-6.739 12.437-13.85 20.464-18.058 24.603zM33.99 165.544c-4.466-4.608-8.398-9.62-11.773-14.95h40.051c6.68 19.328 15.697 32.751 22.8 41.17-19.276-2.715-37.084-11.784-51.078-26.22zM7.74 100.518h45.557c.053 3.863.27 7.716.662 11.55 1.172 11.485 3.252 21.74 5.88 30.85H17.854c-6.557-12.938-10.058-27.391-10.114-42.4zm14.478-50.807h40.047c-2.184 5.92-3.984 11.9-5.378 17.9-1.95 8.388-3.109 16.823-3.477 25.231H8.014c1.169-15.518 6.052-30.262 14.204-43.131zM33.99 34.76C47.88 20.432 65.53 11.39 84.64 8.602c-4.016 5.33-9.589 13.528-14.955 24.117-1.56 3.078-3.01 6.186-4.355 9.317H27.643c1.98-2.519 4.094-4.948 6.348-7.273zM97.377 7.677c.958 0 1.913.02 2.867.052 2.532 2.923 10.908 13.116 18.727 28.546.967 1.91 1.89 3.83 2.77 5.761h-48.23c.846-1.855 1.73-3.702 2.656-5.538 7.84-15.532 16.33-25.866 18.858-28.789.783-.02 1.566-.032 2.352-.032zm63.386 27.086c2.253 2.325 4.368 4.754 6.348 7.273h-37.192c-1.345-3.13-2.795-6.24-4.355-9.317-5.34-10.538-10.885-18.707-14.897-24.04 18.9 2.881 36.34 11.892 50.096 26.084zm-26.25 65.756c-.052 3.595-.257 7.18-.622 10.747-1.138 11.16-3.237 21.737-6.27 31.654H67.63c-3.033-9.917-5.131-20.494-6.27-31.654-.364-3.567-.568-7.152-.622-10.747h73.776zm-.121-7.676H60.859c.361-7.758 1.437-15.543 3.228-23.29 1.539-6.653 3.607-13.288 6.172-19.841h54.732c2.546 6.503 4.602 13.087 6.137 19.69 1.812 7.797 2.9 15.633 3.264 23.441zm56.294 24.9c-.198.102-.416.153-.633.153-.173 0-.347-.032-.512-.099-.372-.148-.666-.452-.81-.837l-2.303-6.16c-1.25 11.312-4.484 22.164-9.529 32.12h-41.488c2.629-9.11 4.708-19.366 5.88-30.85.391-3.835.61-7.688.662-11.55h19.822l-11-7.575c-.044-.032-.087-.066-.127-.102h-8.807c-.368-8.408-1.528-16.843-3.477-25.23-1.395-6-3.194-11.981-5.379-17.901h39.551c4.75 7.497 8.387 15.632 10.829 24.185l4.945 5.572c.056.063.103.131.146.201l3.592-1.85c-4.004-18.222-12.904-34.95-26.024-48.485C147.688 10.418 123.308 0 97.377 0 71.445 0 47.066 10.418 28.729 29.334 10.393 48.25.295 73.4.295 100.153c0 26.751 10.098 51.902 28.434 70.818 18.337 18.917 42.716 29.334 68.648 29.334 25.931 0 50.311-10.417 68.647-29.334 14.555-15.015 23.912-33.96 27.156-54.514l-2.494 1.285z" mask="url(#jbxqthwzub)" />
                          </g>
                          <g transform="translate(-796 -331) translate(796 331) translate(12.978 62.553) translate(19.035 47.362) translate(3.683) translate(0 97.96)">
                            <mask id="zdg7y4fw5d" fill="#fff">
                              <use xlinkHref="#z2vzudqdqc" />
                            </mask>
                            <path fill="#3E5473" d="M192.725 3.132c-18.013 7.312-39.025 14.198-61.282 20.022-32.574 8.524-63.858 13.74-88.09 14.69-11.642.456-20.964-.1-27.708-1.65-5.98-1.376-9.611-3.505-10.224-5.996-.602-2.45 1.532-6.04 6.008-10.109 5.058-4.597 12.782-9.586 22.955-14.828L32.01.355C8.8 12.315-1.878 22.81.27 31.545c1.95 7.934 13.843 11.94 35.39 11.94 2.502 0 5.135-.055 7.895-.163 24.593-.963 56.27-6.238 89.195-14.854 23.88-6.248 46.366-13.72 65.338-21.643l-5.363-3.693z" mask="url(#zdg7y4fw5d)" />
                          </g>
                          <g transform="translate(-796 -331) translate(796 331) translate(12.978 62.553) translate(19.035 47.362) translate(3.683) translate(210.108 51.904)">
                            <mask id="ejdvllo8bf" fill="#fff">
                              <use xlinkHref="#dghh24dr8e" />
                            </mask>
                            <path fill="#3E5473" d="M40.527 12.086C38.44 3.596 24.901-.396.267.213l.127 5.482c24.239-.603 33.965 3.603 34.982 7.74.612 2.49-1.596 6.148-6.218 10.297-.385.346-.79.694-1.204 1.044.646.677 1.195 1.457 1.618 2.331.424.876.697 1.789.832 2.708 8.025-6.507 11.425-12.438 10.123-17.729" mask="url(#ejdvllo8bf)" />
                          </g>
                        </g>
                        <path fill="#3E5473" d="M234.585 88.533l-9.873 5.093c-.571.295-.884.946-.767 1.595l2.945 16.28-5.946 3.067-5.38-14.413c-.145-.388-.441-.695-.816-.845-.168-.068-.344-.101-.52-.101-.217 0-.435.051-.634.154l-10.582 5.458-18.842-12.994 3.946-2.036 8.843 3.568c.376.152.797.132 1.159-.055l31.035-16.011c2.998-1.548 6.658-.285 8.155 2.814 1.498 3.099.276 6.879-2.723 8.426zm-31.998-12.526l6.125-3.169 7.135 8.075-7.856 4.065-5.404-8.97zm25.325-1.237l-9.346 4.82c-.045-.071-.092-.14-.148-.205l-8.068-9.1c-.434-.489-1.128-.62-1.7-.325l-8.351 4.305c-.362.187-.63.523-.74.925-.11.402-.051.833.163 1.188l5.958 9.857-8.35 4.305-8.877-3.58c-.378-.151-.8-.132-1.164.056l-6.744 3.477c-.458.237-.76.707-.792 1.234-.032.528.21 1.033.636 1.327l21.664 14.935c.43.295.979.33 1.44.093l9.95-5.131 5.4 14.462c.146.39.444.698.822.849.167.067.343.1.518.1.22 0 .44-.053.642-.156l8.35-4.306c.574-.296.888-.949.77-1.6l-2.956-16.335 8.941-4.61c4.427-2.283 6.231-7.86 4.02-12.433-2.21-4.572-7.61-6.436-12.038-4.152z" transform="translate(-796 -331) translate(796 331) translate(12.978 62.553) translate(19.035 47.362) translate(3.683)" />
                      </g>
                    </g>
                    <g transform="translate(-796 -331) translate(796 331) translate(12.978 62.553) translate(0 7)">
                      <ellipse cx="63.194" cy="66.593" fill="#9CADC6" rx="41.908" ry="43.471" />
                      <text fill="#FFF" fontFamily="Roboto-Bold, Roboto" fontSize="12" fontWeight="bold">
                        <tspan x="35.693" y="94.256">Countries</tspan>
                      </text>
                      <text fill="#FFF" fontFamily="PlayfairDisplay-ExtraBold, Playfair Display" fontSize="66" fontWeight="600">
                        <tspan x="46.667" y="73.133">7</tspan>
                      </text>
                    </g>
                    <g transform="translate(-796 -331) translate(796 331) translate(12.978 62.553) translate(189.485 180.51)">
                      <mask id="45efzsfogh" fill="#fff">
                        <use xlinkHref="#glx9v4bs2g" />
                      </mask>
                      <use fill="#9CADC6" xlinkHref="#glx9v4bs2g" />
                      <text fill="#FFF" fontFamily="Roboto-Bold, Roboto" fontSize="12" fontWeight="bold" mask="url(#45efzsfogh)">
                        <tspan x="19.385" y="56.858">States</tspan>
                      </text>
                      <text fill="#FFF" fontFamily="PlayfairDisplay-ExtraBold, Playfair Display" fontSize="42" fontWeight="600" mask="url(#45efzsfogh)">
                        <tspan x="13.447" y="38.547">49</tspan>
                      </text>
                    </g>
                    <g transform="translate(-796 -331) translate(796 331) translate(12.978 62.553) translate(50.183 192.128)">
                      <use fill="#9CADC6" xlinkHref="#issworxy8i" />
                      <text fill="#FFF" fontFamily="Roboto-Bold, Roboto" fontSize="12" fontWeight="bold">
                        <tspan x="23.14" y="71.349">Cities</tspan>
                      </text>
                      <text fill="#FFF" fontFamily="PlayfairDisplay-ExtraBold, Playfair Display" fontSize="32" fontWeight="600">
                        <tspan x="14.139" y="55">198</tspan>
                      </text>
                    </g>
                  </g>
                  <path fill="#9CADC6" d="M274.73 91.7c-.5 0-.994.027-1.483.074-3.35-9.237-12.007-15.817-22.162-15.817-10.534 0-19.455 7.08-22.513 16.861-1.798-.719-3.751-1.118-5.796-1.118-8.83 0-15.986 7.355-15.986 16.428h83.927c0-9.073-7.157-16.428-15.986-16.428" transform="translate(-796 -331) translate(796 331)" />
                  <g transform="translate(-796 -331) translate(796 331) translate(46.722 22.34)">
                    <mask id="gyh1smn01k" fill="#fff">
                      <use xlinkHref="#cfb46zsibj" />
                    </mask>
                    <path fill="#9CADC6" d="M79.203 8.655c-4.006 0-7.645 1.6-10.349 4.206-2.704-2.607-6.343-4.206-10.349-4.206-.953 0-1.884.094-2.788.267C52.361 3.558 46.493 0 39.811 0c-7.45 0-13.892 4.42-16.964 10.84-2.264-1.387-4.91-2.185-7.74-2.185C6.763 8.655 0 15.583 0 24.128h94.31c0-8.545-6.763-15.473-15.107-15.473" mask="url(#gyh1smn01k)" />
                  </g>
                  <g transform="translate(-796 -331) translate(796 331) translate(127.189 361.915)">
                    <mask id="wck5dew12m" fill="#fff">
                      <use xlinkHref="#46qn2miy8l" />
                    </mask>
                    <path fill="#9CADC6" d="M86.198 35.745c1.857-3.46 2.92-7.443 2.92-11.685C89.122 10.775 78.743.003 65.936 0c-9.043-.001-16.874 5.371-20.698 13.206-.818-.097-1.649-.151-2.493-.151-9.6-.002-17.752 6.42-20.691 15.348-2.176-1.028-4.59-1.607-7.136-1.607C8.542 26.794 2.979 30.388 0 35.728l86.198.017z" mask="url(#wck5dew12m)" />
                  </g>
                </g>
              </g>
            </g>
          </svg>

        </div>

        <Arrows viewId="1" toCardId="2" color="dark" size="med" />
      </div>

      {/* Card 2: What (I am Expressive) */}
      <div id="view-1-card-2" className="card hero">
        <div className="hero__wrap hero__wrap--has-bg">
          <div className="hero__inner inner">
            <h2 className="hdg-what">
              <span className="hdg-what__major">
                I am <br />
                Expressive.
              </span>{" "}
              <span>I announce. I promote. I connect.</span>
            </h2>

            <blockquote className="quote">
              <p className="quote__what">
                He is an incredible host and emcee. Whether it was a scripted element or an element that he had to ad lib, he always brought incredible
                professionalism and passion to everything he was asked to do.
              </p>
              <footer className="quote__credit">
                <cite>Christopher Cunanan</cite>{" "}
                <span>Manager, Game Entertainment</span>{" "}
                <span>Los Angeles Lakers</span>
              </footer>
            </blockquote>
          </div>
        </div>

        <Arrows viewId="1" toCardId="3" color="light" size="med" />
        <Img fluid={whatSources} />
      </div>

      {/* Card 3: Worked with people */}
      <div id="view-1-card-3" className="card card--worked">
        <div className="inner inner--worked">
          <h2 className="hdg-2 hdg-2--worked ctr">
            I’ve worked with a lot of great people
          </h2>

          <CardWorkedList />
        </div>

        <Arrows viewId="1" toCardId="4" color="dark" size="med" />
      </div>

      {/* Card 4: At a lot of events */}
      <div id="view-1-card-4" className="card card--at-events bgc-01">
        <div className="inner inner--events">
          <h2 className="hdg-2 hdg-2--events ctr">At a lot of events</h2>

          <ul className="at-events">
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 80 78"
                className="at-event__svg-sport"
              >
                <g
                  fill="none"
                  fillRule="evenodd"
                  stroke="#38005D"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g transform="translate(1.648 1.515)">
                    <ellipse
                      cx="28.07"
                      cy="27.857"
                      strokeWidth="2.25"
                      rx="26.316"
                      ry="26.116"
                    />
                    <path
                      strokeWidth="2.25"
                      d="M8.828 45.674c3.207-9.65 13.018-30.622 38.657-35.446m-39.064.265c10.489 3.79 30.11 14.114 34.225 39.14"
                    />
                    <path
                      strokeWidth="2.25"
                      d="M24.618 1.964a19.233 19.233 0 01-6.349 15.196 19.553 19.553 0 01-15.848 4.824"
                    />
                    <path
                      strokeWidth="1.5"
                      d="M27.581 53.969c-10.924-17.388 9.542-37.324 26.8-26.597"
                    />
                  </g>
                  <g strokeWidth="2.25">
                    <path
                      fill="#FFF"
                      d="M75.678 21.596a6.918 6.918 0 00-2.045-5.168 7.03 7.03 0 00-5.207-2.029c-8.584.325-23.132 2.438-33.022 12.26-9.89 9.822-12.023 24.242-12.348 32.776a6.91 6.91 0 002.044 5.167 7.028 7.028 0 005.207 2.03c8.597-.321 23.144-2.438 33.034-12.255 9.89-9.818 12.012-24.248 12.337-32.781z"
                    />
                    <path d="M58.139 31.81L40.595 49.221m6.14-11.317l5.263 5.223m-11.403.87l5.263 5.224m7.017-17.411l5.264 5.223M24.632 47.308l17.89 17.754m31.579-31.339l-17.89-17.755" />
                  </g>
                </g>
              </svg>
              Sport
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 62 62"
                className="at-event__svg-ent"
              >
                <g
                  fill="none"
                  fillRule="evenodd"
                  stroke="#38005D"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2.25"
                >
                  <path d="M17.847 6.79V5.203m0 30.417v-6.711M44.981 6.79V5.203m0 30.417v-6.783m0 0l-27.134.072V6.79h27.134zm.811 6.783H17.035l-2.858 2.921a2.303 2.303 0 00-.482 2.465 2.216 2.216 0 002.035 1.398h31.358c.9-.01 1.703-.562 2.035-1.398a2.303 2.303 0 00-.481-2.465l-2.85-2.921zm-32.079 3.618l-3.634-15.489m38.463 14.682l4.283-14.682m-34.978 0H5.975m39.006 0h11.871M43.448 42.404L19.542 55.971m0-13.567l23.743 13.567" />
                  <path
                    fill="#FFF"
                    d="M30.86 13.232a.622.622 0 011.108 0l1.284 2.594c.09.18.263.306.464.334l2.885.416a.62.62 0 01.495.412.599.599 0 01-.151.622l-2.097 2.035a.598.598 0 00-.174.533l.493 2.863a.606.606 0 01-.246.595.624.624 0 01-.65.043l-2.568-1.346a.624.624 0 00-.579 0l-2.568 1.344a.627.627 0 01-.65-.043.607.607 0 01-.246-.595l.493-2.854a.598.598 0 00-.174-.533l-2.096-2.035a.602.602 0 01-.152-.622.617.617 0 01.496-.428l2.885-.416a.612.612 0 00.463-.334l1.285-2.585z"
                  />
                </g>
              </svg>
              Entertainment
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 73 72"
                className="at-event__svg-tech"
              >
                <g
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    stroke="#38005D"
                    strokeWidth="2.25"
                  >
                    <g>
                      <g>
                        <g>
                          <path d="M7.5 30L7.5 0M0 8.298L0 16.379 7.5 21.702M7.5 19.787L15 14.408 15 6.383" transform="translate(-1057 -208) translate(1057 208) translate(26 17) translate(3 6)" />
                        </g>
                        <g fill="#FFF">
                          <path d="M.074 12.461c0-1.657 1.343-3 3-3s3 1.343 3 3-1.343 3-3 3-3-1.343-3-3zM7.537 3.24c0-1.657 1.343-3 3-3s3 1.343 3 3-1.343 3-3 3-3-1.343-3-3zM15 10.53c0-1.656 1.343-3 3-3s3 1.344 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3zM7.537 38.81c0-1.656 1.343-3 3-3s3 1.344 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3z" transform="translate(-1057 -208) translate(1057 208) translate(26 17)" />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              Tech
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 79 72"
                className="at-event__svg-charity"
              >
                <g
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    stroke="#38005D"
                  >
                    <g>
                      <g>
                        <path strokeWidth="2.25" d="M17.91 41s.874-9.234-2.818-13.356l-5.635-6.046s-1.458-1.282-2.915-.092c-1.457 1.191.486 2.84.486 2.84l3.109 3.847" transform="translate(-975 -209) translate(975 209) translate(17 17)" />
                        <path strokeWidth="2.25" d="M6.079 20.746l-2.673-3.614s-.83-1.806-2.58-.855c0 0-1.29.665-.645 3.518.645 2.853 2.12 10.65 2.12 10.65s.727 1.822 1.658 2.663c1.474 1.33 5.152 4.004 5.621 4.944.47.94.418 2.948.418 2.948M26.09 41s-.874-9.234 2.818-13.356l5.635-6.046s1.458-1.282 2.915-.092c1.457 1.191-.486 2.84-.486 2.84l-3.109 3.847" transform="translate(-975 -209) translate(975 209) translate(17 17)" />
                        <path strokeWidth="2.25" d="M37.921 20.746l2.673-3.614s.83-1.806 2.58-.855c0 0 1.29.665.645 3.518-.645 2.853-2.12 10.65-2.12 10.65s-.727 1.822-1.658 2.663c-1.474 1.33-5.152 4.004-5.621 4.944-.47.94-.418 2.948-.418 2.948" transform="translate(-975 -209) translate(975 209) translate(17 17)" />
                        <path fill="#FFF" strokeWidth="2.25" d="M20.79 9.122C21.182 9.042 21.587 9 22 9c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6c0-.351.03-.696.088-1.03" transform="translate(-975 -209) translate(975 209) translate(17 17)" />
                        <path fill="#FFF" strokeWidth="2.25" d="M7 7.5C7 3.358 10.358 0 14.5 0 18.642 0 22 3.358 22 7.5c0 4.142-3.358 7.5-7.5 7.5C10.358 15 7 11.642 7 7.5z" transform="translate(-975 -209) translate(975 209) translate(17 17)" />
                        <path fill="#38005D" d="M14.045 12v-1.107c-.775-.011-1.577-.209-2.045-.482l.32-.735c.482.263 1.177.471 1.926.471.95 0 1.591-.449 1.591-1.074 0-.603-.522-.976-1.51-1.304-1.365-.439-2.207-.943-2.207-1.897 0-.91.789-1.6 2.019-1.765V3h.829v1.063c.802.022 1.35.198 1.738.384l-.334.724c-.281-.132-.83-.373-1.685-.373-1.03 0-1.417.504-1.417.943 0 .57.495.855 1.658 1.25C16.305 7.45 17 8.02 17 8.995c0 .866-.735 1.678-2.112 1.864V12h-.843z" transform="translate(-975 -209) translate(975 209) translate(17 17)" />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              Charity
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 66 66"
                className="at-event__svg-hosp"
              >
                <g
                  fill="none"
                  fillRule="evenodd"
                  stroke="#38005D"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2.25"
                  transform="translate(4.4 3.52)"
                >
                  <circle cx="17.16" cy="44.44" r="5.72" fill="#FFF" />
                  <path
                    fill="#FFF"
                    d="M29.04 38.72h16c2.828 0 5.12 2.276 5.12 5.084v6.356H29.04V38.72z"
                  />
                  <path d="M29.04 50.16H7.92v7.92m42.24-7.92v7.92m0-44v15.84m-42.24 0V14.08M0 18.48L26.892.647a3.888 3.888 0 014.296 0L58.08 18.48" />
                </g>
              </svg>
              Lifestyle
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 73 72"
                className="at-event__svg-music"
              >
                <g
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    stroke="#38005D"
                  >
                    <g>
                      <g>
                        <path strokeWidth="2.25" d="M35.524 39H3.476C1.564 39 0 37.436 0 35.524V3.476C0 1.564 1.564 0 3.476 0h32.048C37.436 0 39 1.564 39 3.476v32.048C39 37.436 37.436 39 35.524 39z" transform="translate(-1133 -210) translate(1133 210) translate(17 17)" />
                        <path fill="#FFF" strokeWidth="2.5" d="M6 29c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4zM22 25c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4z" transform="translate(-1133 -210) translate(1133 210) translate(17 17)" />
                        <path strokeWidth="2.25" d="M30 23.946L29.859 6 14.015 10.266 14 28" transform="translate(-1133 -210) translate(1133 210) translate(17 17)" />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              Music
            </li>
          </ul>
        </div>

        <Arrows viewId="1" toCardId="5" color="purp" size="med" />
      </div>

      {/* Card 5: How (Positive energy) */}
      <div id="view-1-card-5" className="card hero">
        <div className="hero__wrap hero__wrap--has-bg">
          <div className="hero__inner inner">
            <h2 className="hdg-how">
              <span className="hdg-how__major">My positive energy</span>
              <span>
                and professional speaking experience of over 17 years take your
                event to the next level
              </span>
            </h2>

            <blockquote className="quote">
              <p className="quote__how">
                Nick Ferrara is the ultimate professional Emcee, regardless of the occasion, event type or brand, Nick will show up prepared and ready to deliver. Nick is the host you can trust. He is flexible and operates with the ultimate collaborative spirit with event producers. He’s quick witted, a great listener and can read a crowd like no other.
              </p>
              <footer className="quote__credit">
                <cite>Erica Calhoun</cite> <span>SR VP of Experiential</span>{" "}
                <span>Public Label</span>
              </footer>
            </blockquote>
          </div>
        </div>

        <Arrows viewId="1" toCardId="6" color="light" size="med" />
        <Img fluid={howSources} />
      </div>

      {/* Card 6: Some of my favorite interviews */}
      <div id="view-1-card-6" className="card hero">
        <div className="hero__wrap hero__wrap--interviews">
          <div className="hero__inner inner">
            <h2 className="hdg-2 hdg-2--interviews ctr">
              Some of my favorite interviews...
            </h2>

            <blockquote className="quote quote__margin">
              <p className="quote__interview">
                Never an awkward moment as Nick can entertain a crowd and carry an interview seamlessly and with a friendly and inviting flare. He's great to work with, takes direction easily and definitely leaves the producer with one less thing to worry about!
              </p>
              <footer className="quote__credit">
                <cite>Kelly Reed</cite> <span>Executive Producer</span>{" "}
                <span>Van Wagner Sports & Entertainment (VWSE)</span>
              </footer>
            </blockquote>

            <CardInterviewsList />
          </div>
        </div>

        <Arrows viewId="1" toCardId="7" color="light" size="med" />
        <Img fluid={interviewSources} />
      </div>

      {/* Card 7: Social */}
      <Social />

      {/* Card 8: Get in touch */}
      <Contact />
    </section>
  );
}
